module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.30b4afd9.svg";